import React from "react";
import { useTheme } from "styled-components";
import {
  Date,
  Image,
  ImageDateContainer,
  ImageOverlay,
  Text,
  TextArrowContainer,
  Title,
  TitleTextWrapper,
  Wrapper,
} from "./styles";
import Arrow from "../Arrow";
import { buildDateAndSplit } from "../../../dateFormatting";
import { useAtlassianLocale } from "@Shared/Hooks/useAtlassianLocale";
import { LAYOUT_STRUCTURE_OPTIONS } from "../../../../../optics/components/drawers/settings/features/announcements/defaults";
import EditableText from "../../inline-edit/EditableText";
import EditableLine from "../../inline-edit/EditableLine";
import { handleLinkClick } from "../../../../../helpers/handle-link-click";

function Background({ data, config, viewMode = "view", isEditable }) {
  const [locale] = useAtlassianLocale();
  const { title, linkText, date, image, color, textColor } = data;
  const { borderRadius, layoutStructure } = config;

  const theme = useTheme();

  const isBig = config.view === "list";
  const { link: imageUrl, focalPoint } = image || {};
  const hasLink = viewMode === "view" && !!data?.url?.link;

  const builtDate = buildDateAndSplit(date, false, locale, config.designStyle);
  return (
    <Wrapper
      isBig={isBig}
      borderRadius={borderRadius}
      imageUrl={imageUrl}
      position={focalPoint}
      hasLink={hasLink}
      onClick={() => {
        if (hasLink) {
          handleLinkClick({
            url: data?.url || {},
            newTab: data?.newTab === "true",
          });
        }
      }}
    >
      {data?.overlay?.isActive && (
        <ImageOverlay opacity={data?.overlay?.opacity} />
      )}
      <ImageDateContainer>
        <Image isBig={isBig} imageUrl={imageUrl} position={focalPoint} />
        {layoutStructure.includes(LAYOUT_STRUCTURE_OPTIONS.DATE) &&
          !!Object.keys(builtDate).length && (
            <Date
              isBig={isBig}
              bgClr={color[theme.name]}
              textClr={textColor[theme.name]}
            >
              <span>{builtDate?.month?.toUpperCase()}</span>
              <span className="date-day">{builtDate?.day}</span>
            </Date>
          )}
      </ImageDateContainer>
      <TitleTextWrapper>
        <Title isBig={isBig}>
          <EditableText
            announcementId={data.id}
            isEditable={isEditable}
            value={title}
            propKey="title"
            disableNewLine
            minHeight={isBig && "1.1em"}
          />
        </Title>
        {(layoutStructure.includes(LAYOUT_STRUCTURE_OPTIONS.LINK) ||
          layoutStructure.includes(LAYOUT_STRUCTURE_OPTIONS.ARROW)) && (
          <TextArrowContainer>
            {layoutStructure.includes(LAYOUT_STRUCTURE_OPTIONS.LINK) && (
              <Text>
                <EditableLine
                  isEditable={isEditable}
                  value={linkText}
                  propKey="linkText"
                />
              </Text>
            )}
            {layoutStructure.includes(LAYOUT_STRUCTURE_OPTIONS.ARROW) && (
              <Arrow size="18" />
            )}
          </TextArrowContainer>
        )}
      </TitleTextWrapper>
    </Wrapper>
  );
}

export default Background;
